$(function(){

  // init
  // $.url().param("area");

  if( $.url().param("area") ) {
    var area = $.url().param("area");

    $(".js-bureau-tabs li a").removeClass("is-active");
    $(".js-bureau-tabs li a[data-area='"+ area +"']").addClass("is-active");

    $(".bureauspot__post article").removeClass("is-show");
    $("#area-" + area).addClass("is-show");
  }

  // actions
  $(".js-bureau-tabs li a") .on('click', function(){
    var area = $(this).attr("data-area");

    $(".js-bureau-tabs li a").removeClass("is-active");
    $(".js-bureau-tabs li a[data-area='"+ area +"']").addClass("is-active");

    $(".bureauspot__post article").removeClass("is-show");
    $("#area-" + area).addClass("is-show");

    if ( area === "all" ) {
      $(".bureauspot__post article").addClass("is-show");
    }
  });
});


// WEBPACK FOOTER //
// ./_src/js/cont/bureau-list.js